<div class="flex flex-col update-definition-dialog">
    <app-sidenav-header [title]="title" [subtitle]="subtitle"></app-sidenav-header>
    <div class="flex flex-row justify-between header mb-24 w-100-percent">
      <div class="mat-body-2 fw-700">
        <span class="mr-8 mat-headline-6 fw-700 fs-16">{{ 'INSTANCE_SUMMARY.SERVICE_DEFINITION.SERVICE_DEFINITION' | transloco }}</span>
        <span>({{ filteredConfigurations.length === blueprintsVersionList.length ? blueprintsVersionList.length :
          ('COMMON.NUMBER_OF_TOTAL' | transloco : {num: filteredConfigurations.length , total:blueprintsVersionList.length }) }})</span>
      </div>

      <app-search-filter placeholder="SEARCH.SEARCH" (changed)="search($event)"></app-search-filter>
    </div>
    <div class="tbl tbl-service-definition w-100-percent overflow-y-scroll pr-12" matSort (matSortChange)="sortData($event)">
      <div class="tbl-header-row primary mb-8">
        <div class="tbl-cell col-expand"></div>
        <div class="tbl-cell col-select"></div>
        <div class="tbl-cell col-service-name">
          {{ 'INSTANCE_SUMMARY.SERVICE_DEFINITION.SERVICE_NAME' | transloco }}</div>
        <div class="tbl-cell col-date-generated mr-10" (click)="sortDateTime()">{{ 'INSTANCE_SUMMARY.SERVICE_DEFINITION.DATE_GENERATED' | transloco }} <mat-icon svgIcon="import_export" class="icon-sm"></mat-icon></div>
        <div class="tbl-cell col-status">{{ 'INSTANCE_SUMMARY.SERVICE_DEFINITION.STATUS' | transloco }}</div>
      </div>
      <div *ngFor="let blueprintVersion of pageConfigurations" class="tbl-border mb-8">
        <div class="tbl-body-row tbl-high-row"
          [ngClass]="[selection === blueprintVersion ? 'selected' : (expandedRows[blueprintVersion.id] ? 'expanded' : '')]">
          <div class="justify-items-center tbl-cell col-expand user-select-none"
            (click)="expandRow(blueprintVersion)">
            <mat-icon class="cursor-pointer"
            [svgIcon]="expandedRows[blueprintVersion.id] ? 'expand_more' : 'chevron_right'"></mat-icon>
          </div>
          <div class="justify-items-center tbl-cell col-select user-select-none">
            <mat-icon *ngIf="(blueprintVersion.version <= deployedVersion); else notInprogress" svgIcon="radio_button_unchecked" class="radio-icon cursor-not-allowed disabled"></mat-icon>
            <ng-template #notInprogress>
              <mat-icon *ngIf="selection !== blueprintVersion" (click)="select(blueprintVersion)" svgIcon="radio_button_unchecked" class="radio-icon cursor-pointer"></mat-icon>
              <mat-icon *ngIf="selection === blueprintVersion" (click)="select(blueprintVersion)" svgIcon="radio_button_checked" class="radio-icon cursor-pointer"></mat-icon>
            </ng-template>
          </div>
          <div class="tbl-cell col-service-name">
            {{ 'INSTANCE_SUMMARY.SERVICE_DEFINITION.VERSION' | transloco}} {{ blueprintVersion.version }}
          </div>
          <div class="tbl-cell col-date-generated">
            {{ 'INSTANCE_SUMMARY.SERVICE_DEFINITION.CREATED_ON' | transloco}} {{ blueprintVersion.dateCreated | date: Constants.DATE_TIME_FORMAT: Constants.DATE_TIME_UTC_OFFSET }}
          </div>
          <div class="tbl-cell col-status">
            {{ deployedVersion===blueprintVersion.version? ('INSTANCE_SUMMARY.SERVICE_DEFINITION.DEPLOYED' | transloco) : blueprintVersion.version < deployedVersion? ('INSTANCE_SUMMARY.SERVICE_DEFINITION.NOT_AVAILABLE' | transloco) : ('INSTANCE_SUMMARY.SERVICE_DEFINITION.AVAILABLE' | transloco)}}
          </div>
        </div>
        <div *ngIf="expandedRows[blueprintVersion.id]" class="mt-20 mr-16 mb-20 ml-16">
          <div class="flex flex-row justify-between">
            <div class="w-100-percent">
              <div class="section-label">
                <span class="mr-8 mat-headline-6 fw-700 fs-16">{{ 'INSTANCE_SUMMARY.SERVICE_DEFINITION.SELECTED_CAPABILITIES' | transloco }}</span>
                <span>({{blueprintVersion?.capabilities?.length}})</span>
              </div>
              <div class="flex flex-row flex-wrap"> 
                <div class="flex-col w-50-percent mb-0" *ngFor="let includedCapabilities of blueprintVersion?.capabilities">
                  <div class="fw-500 mb-8">{{includedCapabilities?.displayName ? (includedCapabilities?.displayName) : ((includedCapabilities?.name) ? (includedCapabilities?.name) : 'INSTANCE_SUMMARY.SERVICE_DEFINITION.NOT_AVAILABLE' | transloco) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <span class="flex-auto"></span>

    <app-paginator></app-paginator>
    <mat-divider class="mt-32 mb-32 neutral-2"></mat-divider>

    <ng-container>
      <div class="flex flex-row gap-4" dir="rtl">
        <button class="accent" type="button" [ngClass]="{'disabled': !selection}" [disabled]="!selection"
          (click)="applyConfiguration()">{{'BUTTONS.UPDATE' | transloco}}</button>
        <button class="white" type="button" (click)="sidenavService.closeRightSidenav()">{{'BUTTONS.CANCEL' | transloco}}
        </button>
      </div>
    </ng-container>
  </div>
